<template>
  <span class="required-mark" :title="$t('form.validation.required')">*</span>
</template>

<script>
export default {
  name: 'RequiredMark',
};
</script>

<style scoped>
.required-mark {
  color: red;
}
</style>
